module.exports = __webpack_public_path__ + "static/media/earth.59a8bcac.svg";